// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","headerLeft":"Header_headerLeft__vuPuP","headerRight":"Header_headerRight__825O1","link":"Header_link__xIhZh"};